export default __webpack_public_path__ + "static/media/advanceFilter.ebaf3edb.svg";